import { render, staticRenderFns } from "./MeritSalary.vue?vue&type=template&id=5554e571&scoped=true"
import script from "./MeritSalary.vue?vue&type=script&lang=js"
export * from "./MeritSalary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5554e571",
  null
  
)

export default component.exports